var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"show-percentage"},[_c('span',{staticClass:"show-percentage-label"},[_vm._v(_vm._s(_vm.data.label))]),_c('span',{staticClass:"show-percentage-value"},[_vm._v(_vm._s(_vm.row.percentage_completion + "%"))])]),_c('progress-bar',{attrs:{"size":"medium","bar-color":"#5B7AFF","val":_vm.row.percentage_completion}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }